import { getViewConfig, type OrderData } from '../types'
import { isKlachtOpen } from './klacht-types'

export { KLEDA_SOCIAL, socialLink } from '../../api/_lib/social-links'

/** Volgt de bestaande statusindeling, ook voor zelf gebrachte kleden. */
export function toonSocialKaart(order: Pick<OrderData, 'status' | 'klacht' | 'isVervolgWo'>): boolean {
  return getViewConfig(order.status).view === 'in-behandeling'
    && !order.isVervolgWo
    && !(order.klacht && isKlachtOpen(order.klacht.status))
}
